import React from 'react';
import { Link } from 'react-router-dom';
import { LuBell } from 'react-icons/lu';
import { IconButton } from '@mui/material';

export default function FeedbackBell({
  fbBellRef,
  fbPendingCount,
  fbBellOpen,
  fbPendingLoading,
  setFbBellOpen,
  fetchPendingFb,
  setFbPendingLoading,
  t,
}) {
  return (
    <div ref={fbBellRef} style={{ position: 'relative' }}>
      <IconButton
        title={t('header.feedbackPending')}
        aria-label={t('header.feedbackPending')}
        onClick={() => {
          setFbBellOpen(v => {
            const next = !v;
            if (next) fetchPendingFb();
            return next;
          });
        }}
        sx={{ color: 'inherit' }}
      >
        <LuBell style={{ fontSize: '1.2rem' }} />
        {fbPendingCount > 0 && (
          <span className="app-badge-count">{fbPendingCount}</span>
        )}
      </IconButton>

      {fbBellOpen && (
        <div className="app-badge-menu" style={{ minWidth: 260 }}>
          <div className="app-badge-menu-header">
            {t('header.newFeedback')}
          </div>
          <div style={{ padding: 12 }}>
            <div style={{ marginBottom: 8, color: 'inherit' }}>
              {t('header.pendingCount', { count: fbPendingCount })}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
              <button
                type="button"
                disabled={fbPendingLoading}
                onClick={async (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setFbPendingLoading(true);
                  try {
                    const ok = await fetchPendingFb();
                    try {
                      if (ok) {
                        window.dispatchEvent(new Event('feedbackUpdated'));
                        localStorage.setItem('lastFeedbackUpdate', String(Date.now()));
                      }
                    } catch (_) {}
                  } finally {
                    setFbPendingLoading(false);
                  }
                }}
                style={{
                  background: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: 8,
                  padding: '6px 12px', cursor: fbPendingLoading ? 'wait' : 'pointer',
                  color: '#374151', fontSize: '0.85rem',
                  opacity: fbPendingLoading ? 0.6 : 1
                }}
              >{fbPendingLoading ? t('header.refreshing') : t('header.refresh')}</button>
              <Link
                to="/admin/feedback"
                onClick={() => setFbBellOpen(false)}
                style={{
                  color: '#fff', background: '#6366f1', borderRadius: 8,
                  padding: '6px 12px', textDecoration: 'none', fontSize: '0.85rem'
                }}
              >{t('header.openPage')}</Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
